module.exports = __webpack_public_path__ + "static/sat2-9912cd659c1605cff4c4660df7e0361b.jpg";